<div class="download" (click)="click($event)">
  @if (icon) {
    <mat-icon>{{icon}}</mat-icon>
  } @else if (iconPath) {
    <img class="icon-img" [src]="iconPath" alt="download" />
  }
  <p>{{label}}</p>
  </div>
